package com.exura.features.plandefinition.data.remote.dto.series

import com.exura.features.plandefinition.domain.model.series.SeriesSpawnType
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * DTO for SimpleQuestionSeries.
 * Extends BaseAnchoredSeriesDto for Firebase storage compatibility.
 */
@Serializable
@SerialName("question_series")
data class SimpleQuestionSeriesDto(
    override val name: String,
    override val description: String,
    override val seriesType: SeriesSpawnType = SeriesSpawnType.QUESTION,
    override val durationInDays: Int = 0,
    val relativeDay: Int,
    val duration: Int,
    val question: String,
    val options: List<QuestionOptionDto>,
    override val imageUrl: String? = null,
    val estimatedMinutes: Int = 5,
    val reaskEveryDays: Int = 1
) : BaseSeriesDto() {

    @Serializable
    data class QuestionOptionDto(
        val id: String,
        val text: String,
        val responseMessage: String? = null,
        val isResponsePositive: Boolean = true,
    )
}
